import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_76b91bca-f3f4-4613-9a08-ad8c90cec57e/artifacts/xiemrfmz_HomeLyph_Chrome_Logo%20%281%29.png";

// Main logo component for headers/navbars
export const Logo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: "h-12",      // Small - for tight spaces
    md: "h-16",      // Medium - for navbars
    lg: "h-20",      // Large - for headers
    xl: "h-24",      // Extra large - for Coming Soon page
    hero: "h-32"     // Hero size - for prominent displays
  };
  
  return (
    <img 
      src={LOGO_URL}
      alt="HomeLyph Logo"
      className={`${sizes[size]} w-auto ${className}`}
    />
  );
};

// Small logo for footers
export const LogoSmall = ({ className = "" }) => (
  <img 
    src={LOGO_URL}
    alt="HomeLyph Logo"
    className={`h-14 w-auto ${className}`}
  />
);

export default Logo;
